import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import BackgroundOrbs from "@/components/BackgroundOrbs";
import WhatsAppButton from "@/components/WhatsAppButton";

export default function Layout({ children }) {
    return (
        <div className="relative min-h-screen overflow-x-hidden">
            <BackgroundOrbs />
            <Navbar />
            <main data-testid="page-main" className="relative z-10">
                {children}
            </main>
            <Footer />
            <WhatsAppButton />
        </div>
    );
}
